import DashboardLayout from "../components/DashboardLayout";
import { ADMIN_NAV, ADMIN_FOOTER_LINKS } from "../config/adminNav";

const AdminDashboardLayout = () => (
  <DashboardLayout
    navItems={ADMIN_NAV}
    footerLinks={ADMIN_FOOTER_LINKS}
    showVerificationBadge={false}
    shellClassName="dashboard-shell--admin"
  />
);

export default AdminDashboardLayout;
